import React from 'react';
import Device from './Device';

const Hero = () => {
  return (
    <section className="hero">
      <div className="container hero-container">
        <div className="hero-content">
          <h1 className="hero-title">AeroFi <span>RWA</span> Device Packages</h1>
          <p className="hero-subtitle">Select from our range of AI-powered WiFi mining devices to earn passive income through the blockchain while providing global connectivity. Each device offers different mining capacities with token-denominated returns based on the AFI ecosystem.</p>
          <div className="early-adopter-banner">
            <h3>Early Adopter Advantage Program</h3>
            <p>Early participants receive up to 50% higher rewards through our Temporal Reward Adjustment mechanism. The sooner you join, the better your position in the ecosystem.</p>
          </div>
          <div className="btn-group">
            <a href="#products" className="btn">Buy Now</a>
            <a href="#tokenomics" className="btn btn-outline">Learn More</a>
          </div>
        </div>
        <Device />
      </div>
    </section>
  );
};

export default Hero;
